// @ts-expect-error untyped
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
const FORECASTING_SURVEY_KEY = 'FORECASTING_SEPG';
export const triggerWootricSurvey = () => {
  try {
    setupCsat(FORECASTING_SURVEY_KEY);
  } catch (error) {
    logRavenException(error, 'triggerWootricSurvey', {
      FORECASTING_SURVEY_KEY
    });
  }
};